import type { InventoryCategory } from '@jupi/shared'

// The category's name in the signed-in member's language, falling back to
// Finnish (the one name every category has).
export function categoryName(category: Pick<InventoryCategory, 'nameFi' | 'nameSv' | 'nameEn'>, language: string): string {
  const lang = language.slice(0, 2)
  return (lang === 'sv' ? category.nameSv : lang === 'en' ? category.nameEn : null) || category.nameFi
}

export function formatMoney(amount: number, currency: string, language: string): string {
  try {
    return new Intl.NumberFormat(language, { style: 'currency', currency }).format(amount)
  } catch {
    // An unknown currency code: show it plainly rather than throw.
    return `${amount.toFixed(2)} ${currency}`
  }
}

// "73.50 € + $52.00": each currency apart, never summed.
export function formatValue(value: Record<string, number>, language: string): string {
  return Object.entries(value)
    .map(([currency, amount]) => formatMoney(amount, currency, language))
    .join(' + ')
}
